import React, { useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
// @ts-ignore
import html2pdf from "html2pdf.js"
import {docMapping} from "./DocMapping";

interface DownloadProps {
  downloadapplication: any;
}

const ApplicationPreview: React.FC<DownloadProps> = ({ downloadapplication }) => {
    const pdfRef = useRef<HTMLDivElement>(null);
  
    const downloadPDF = () => {
      if (pdfRef.current) {
        const clonedContent = pdfRef.current.cloneNode(true) as HTMLElement;
        clonedContent.style.display = "block";
        html2pdf()
          .from(clonedContent)
          .set({
            margin: 10,
            pagebreak: { mode: ['css', 'legacy'], avoid: ['.avoid-break']},
            filename: `Gca_Application_${downloadapplication.applicationId}.pdf`,
            html2canvas: { scale: 2 },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
          })
          .save();
      }
    };
  
    return (
      <>
        <div className="max-w-3xl mx-auto p-6 border rounded-md shadow-md bg-white">
          <div ref={pdfRef} style={{ display: "none" }}>
            <h1 className="text-center text-2xl font-bold">FORM-V 3</h1>
            <h3 className="text-center">(Rule - 56 (2) (i))</h3>
            <h2 className="text-center text-xl font-semibold">
              APPLICATION FOR UNIFIED LICENSE AS A General Commission Agent
            </h2>

       <div className="row mb-4">
  <div className="col text-start mt-4">
    Application ID: {downloadapplication?.applicationId}
  </div>

  <div className="col text-end mt-4">
    Date:{" "}
    {downloadapplication?.appliedDate
      ? new Date(downloadapplication.appliedDate).toLocaleDateString()
      : "N/A"}
  </div>
</div>

  
            <p className="mt-2">
              To, <br />
              The Director of Agricultural Marketing & Rural Finance/<br />
              The Deputy Director Agricultural Marketing & Rural Finance.
            </p>
  
            <div className="flex justify-between">
              <p>
                Sir, <br />
                I/We {downloadapplication?.applicantName} <br />
                ({downloadapplication?.currAddress[0]?.at}, {downloadapplication?.currAddress[0]?.taluka},{" "}
                {downloadapplication?.currAddress[0]?.district})  am/are making an application for the grant of license as a GCA 
                in any principal market yard, sub-market yard, private market yard,
                 sub-yard,  platform, or any other space.
              </p>
             
            </div>
  
            <h3 className="text-lg font-semibold mt-6">Details of Applicant</h3>
            <p>Name: {downloadapplication?.applicantName}</p>
           {  downloadapplication?.partnerDetails?.length > 0&&  <><h3 className="text-lg font-semibold mt-6">Partners</h3><table className="w-full border-collapse border border-black mt-2" style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
              <thead> 
                <tr>
                  <th className="border border-black p-2">Sr No.</th>
                  <th className="border border-black p-2">Name</th>
                  <th className="border border-black p-2">Age in years</th>
                  <th className="border border-black p-2">Address</th>
                </tr>
              </thead>
              <tbody>
                {downloadapplication.partnerDetails.map(
                  (director, index) => (
                    <tr key={director.id} className="avoid-break" style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
                      <td className="border border-black p-2">{index + 1}.</td>
                      <td className="border border-black p-2">{director.partnerName}</td>
                      <td className="border border-black p-2">{director.partnerAge}</td>
                      <td className="border border-black p-2">{director.partnerAddress}</td>
                    </tr>
                  ))}
              </tbody>
            </table></>}
              <h3 className="text-lg font-semibold mt-6">Current Address</h3>
            <p>
              Address: {downloadapplication?.currAddress[0]?.at},Taluka- {downloadapplication?.currAddress[0]?.taluka},{" "}
             District- {downloadapplication?.currAddress[0]?.district}
            </p>
  
            <h3 className="text-lg font-semibold mt-6">Permanent Address</h3>
            <p>
              Address: {downloadapplication?.perAddress[0]?.at},Taluka- {downloadapplication?.perAddress[0]?.taluka},{" "}
              District-{downloadapplication?.perAddress[0]?.district}
            </p>
  
            <h3 className="text-lg font-semibold mt-6">Address of Registered Office</h3>
            <p>
              Address: {downloadapplication?.regOffAddress[0]?.at}, Taluka-{downloadapplication?.regOffAddress[0]?.taluka},{" "}
             District-{downloadapplication?.regOffAddress[0]?.district}
            </p>
            <p>PAN Card No: {downloadapplication?.panCardNo}</p>
            <p>Election Card No: {downloadapplication?.electionCardNo}</p>
            <p>Registered E-Mail ID: {downloadapplication?.regEmailId || "N/A"}</p>
            <p>Mobile No: {downloadapplication?.mobileNo || "N/A"}</p>

{downloadapplication?.entityType === "Firm" && <div  style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
             <h3 className="text-lg font-semibold mt-6">Firm Details</h3>
             <p>Firm Name: {downloadapplication?.entityName}</p>
            <p>Firm Registration No: {downloadapplication?.entityRegistrationNo}</p>
            <p>Firm GST No: {downloadapplication?.entityGstNo || "N/A"}</p>
            <p>Firm PAN No: {downloadapplication?.entityPanNo || "N/A"}</p>
            <p>FPO No: {downloadapplication?.entityFpoNo || "N/A"}</p>
</div>}
          
          <div style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
         <h3 className="text-lg font-semibold mt-6">Bank Details</h3>
            <table className="w-full border-collapse border border-black mt-2" style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
              <thead>
                <tr>
                  <th className="border border-black p-2">Sr no</th>
                  <th className="border border-black p-2">Account no</th>
                  <th className="border border-black p-2">IFSC Code</th>
                  <th className="border border-black p-2">Account Type</th>
                  <th className="border border-black p-2">Bank Name</th>
                  <th className="border border-black p-2">Branch Name</th>
                </tr>
              </thead>
              <tbody>
                {downloadapplication?.bankDetails?.map(
                                  (rep, index) => (
                                    <tr key={rep.id} className="avoid-break" style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
                                      <td className="border border-black p-2">{index + 1}.</td>
                                      <td className="border border-black p-2">{rep?.acct_no}</td>
                                      <td className="border border-black p-2">{rep?.ifsc_code}</td>
                                      <td className="border border-black p-2">{rep?.acct_type}</td>
                                      <td className="border border-black p-2">{rep?.bank_name}</td>
                                      <td className="border border-black p-2">{rep?.branch_name}</td>
                                    </tr>
                                  )
                                )}
              </tbody>
            </table>
            </div>
               <div style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
            <h3 className="text-lg font-semibold mt-6">Representatives</h3>
            <table className="w-full border-collapse border border-black mt-2" style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
              <thead>
                <tr>
                  <th className="border border-black p-2">No.</th>
                  <th className="border border-black p-2">Name</th>
                  <th className="border border-black p-2">Age (Years)</th>
                  <th className="border border-black p-2">Address</th>
                </tr>
              </thead>
              <tbody>
                {downloadapplication?.representatives.map((rep: any, index: number) => (
                  <tr key={index} className="avoid-break" style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
                    <td className="border border-black p-2">{index + 1}</td>
                    <td className="border border-black p-2">{rep?.name}</td>
                    <td className="border border-black p-2">{rep?.age}</td>
                    <td className="border border-black p-2">{rep?.address}</td>
                  </tr>
                ))}
              </tbody>
            </table>
  </div>
            <div style={{pageBreakInside:'avoid', breakInside:'avoid'}}>
            <h3 className="text-lg font-semibold mt-5">Documents Enclosed</h3>
            <ol className="list-decimal list-inside mt-4" >
              {downloadapplication?.docs.map((doc: any, index: number) => (
                <li key={index} className="avoid-break" style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>{docMapping[doc?.documentName]}</li>
              ))}
            </ol>
            </div>
          
  
            <p className="mt-4">Date: ________________ Signature: ________________</p>
  
            <h3 className="text-lg font-semibold mt-6">Guarantors</h3>
            <table className="w-full border-collapse border border-black mt-2" style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
              <thead>
                <tr>
                  <th className="border border-black p-2">Guarantor Name</th>
                  <th className="border border-black p-2">Address</th>
                  <th className="border border-black p-2">PAN Card No</th>
                </tr>
              </thead>
              <tbody>
                {downloadapplication?.guarantorDetails?.map((guarantor: any, index: number) => (
                  <tr key={index} className="avoid-break" style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
                    <td className="border border-black p-2">{guarantor?.name}</td>
                    <td className="border border-black p-2">{guarantor?.address}</td>
                    <td className="border border-black p-2">{guarantor?.panCardNo}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
  
        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <button
            onClick={downloadPDF}
            style={{
              padding: "10px 20px",
              fontSize: "16px",
              cursor: "pointer",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "5px",
            }}
          >
            Download PDF
          </button>
        </div>
      </>
    );
  };
  
  export default ApplicationPreview;
  

